import { useContext } from 'react';
import { useCartDetailsAPI } from './useAxios';

import DataContext from '../store/dataContext';

export const useProduct = () => {
  const { apiResponse } = useCartDetailsAPI();
  const { cartDetails } = useContext(DataContext);

  const allDigital = () => {
    if (cartDetails?.lineItems) {
      return cartDetails.lineItems.every(item => item.productType === 'digital');
    }
    if (apiResponse?.cart?.lineItems) {
      return apiResponse.cart.lineItems.every(item => item.productType === 'digital');
    }
    return false;
  };

  return { allDigital };
};
